import { Button, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    APIS,
    URLS,
    SF_UCR_RCPN_MGMT_SRCH,
    SG_UCR_RCPN_MGMT_LIST,
} from "@/tra/tancis/ptli/elctdoc/ucr/service/PtliUcrRcpnMgmtService";

/*
 * UCR Transfer List
 * !== UCR 이관 목록 ==!
 */
export const PTLI0704001Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    }); 
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "PTL0013" }, { area: "tinNo" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Get a list of UCR transfers. !== UCR 이관 목록을 조회한다.==!
        ucrRcpnMgmtSrch: useForm({
            defaultSchema: SF_UCR_RCPN_MGMT_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        ucrRcpnMgmtList: useGrid({
            defaultSchema: SG_UCR_RCPN_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get the UCR Reception management list. !== UCR 수관 관리 목록을 조회한다.==!
        getUcrRcpnMgmtList: useFetch({
            api: (page = grid.ucrRcpnMgmtList.page) => {
                return APIS.getUcrRcpnMgmtList(form.ucrRcpnMgmtSrch.getValues(), page, grid.ucrRcpnMgmtList.size);
            },
            enabled: comnUtils.isEmpty(form.ucrRcpnMgmtSrch.errors) && form.ucrRcpnMgmtSrch.isSubmitted,
            key: [grid.ucrRcpnMgmtList.page, grid.ucrRcpnMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.ucrRcpnMgmtSrch.getValues(),
                    page: grid.ucrRcpnMgmtList.page,
                    size: grid.ucrRcpnMgmtList.size,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        getUcrTrsfList: (page: number = 0) => {
            form.ucrRcpnMgmtSrch.handleSubmit(
                () => {
                    grid.ucrRcpnMgmtList.setPage(page);
                    fetch.getUcrRcpnMgmtList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };

    const render = {
        cell: {
            ucrNo: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.ptli0704002s}/${rowValues.ucrNo}-${rowValues.ucrtSrno}`}>{value}</Link>;
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.getUcrTrsfList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtSrch.schema.ucrNo}></Group.Control>
                            <Group.Control
                                {...form.ucrRcpnMgmtSrch.schema.ucrtAprvDoneYn}
                                select={true}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtSrch.schema.ucrtAprvDoneDtm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.ucrRcpnMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getUcrTrsfList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.ucrRcpnMgmtList.grid}
                            data={fetch.getUcrRcpnMgmtList.data?.ucrRcpnMgmtList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
